<template>
  <div class="c-take-curse">
    <div class="c-take-curse__title px-4">
      <div v-if="false">
        <h2 class="text-center fs-18 sec-medium">
          Acceso a todo nuestro contenido desde:
        </h2>
        <div class="d-flex align-items-center justify-content-center">
          <p class="text-end fs-25 mb-0 me-2 sec-light">
            <del> {{currency}} {{membershipPrice.before.toFixed(2)}} </del>
          </p>
          <p class="fs-30 mb-0 text-start">
            {{currency}} {{membershipPrice.current.toFixed(2)}}
          </p>
        </div>
        <p class="mb-4 text-center fs-18 sec-medium">
          Mensual
        </p>
        <router-link to="/membresias" class="c-button c-button--primary text-center w-100 mb-4">
          <span class="d-flex me-2">
            <Icon icon="fa-solid:crown"/>
          </span>
          Suscribete Ahora
        </router-link>
        <div class="c-hr mb-4"></div>
      </div>
      <h2 class="text-center fs-18 sec-medium">
        Accede a este curso solo por:
      </h2>
      <p class="fs-30 mb-2 mb-lg-4 text-center">
        {{currency}} {{Number(course.price.current.local).toFixed(2)}}
      </p>

      <div v-if="course.enrollment" class="">
        <router-link
          to="/panel"
          class="c-button c-button--primary w-100"
        >
          Reproducir curso
        </router-link>
      </div>
      <div v-else-if="isAuthenticated && userData.subscriber" class="mb-3">
        <button
          @click="enrollAtCourse(course.post.id)"
          class="c-button c-button--primary w-100"
          :class="{'loading' : isLoadingEnroll}"
          :disabled="isLoadingEnroll"
        >
          Inscribirse

          <span class="c-button__spinner ms-2">
            <Icon icon="eos-icons:loading" />
          </span>
        </button>
      </div>
      <div v-else class=" mb-3">
        <div v-if="course.price.current.local > 0" class="d-flex">
          <button
            @click="addToCart()"
            class="c-button c-button--trolley me-4"
            :class="{'enabled' : checkIsOnCart}"
          >
            <span class="fs-21">
              <Icon icon="ant-design:shopping-cart-outlined"/>
            </span>
          </button>
          <router-link
            :to="checkoutProduct"
            class="c-button c-button--primary w-100"
          >
            <p class="mb-0 text-center w-100">
              Comprar curso
            </p>
          </router-link>
        </div>
        <div v-else class="d-flex">
          <button
            @click="handleGetFreeCourseAccess(course.post.id)"
            class="c-button c-button--primary w-100"
            :disabled="btnLoading"
          >
            <p class="mb-0 text-center w-100">
              Acceso gratuito
              <span v-if="btnLoading" class="fs-18 ms-2">
                <Icon icon="eos-icons:loading" />
              </span>
            </p>
          </button>
        </div>

      </div>
      <div class="" v-if="!course.enrollment">
        <div class="d-flex align-items-center justify-content-center mb-3">
          <p class="text-center fs-18 sec-color w-medium mb-0">
            Paga con
          </p>
          <figure class="c-logo-yape mx-2">
            <img src="@/assets/img/yape-logo.png" alt="" class="w-100 h-100 of--cover">
          </figure>
          <span class="w-sbold text-center fs-18 sec-color">
            900118354
            </span>
        </div>
        <figure class="c-yape-qr d-none d-lg-block">
          <img src="@/assets/img/qr.jpg" alt="" class="w-100 h-100 of--contain">
        </figure>
      </div>
    </div>
    <ul class="c-take-curse__ul ul-reset">
      <li class="c-take-curse__li">
        <p class="mb-0">
          <span class="fs-25 me-2">
            <Icon icon="healthicons:happy-outline"/>
          </span>
          Online y a tu ritmo
        </p>
      </li>
      <li class="c-take-curse__li">
        <p class="mb-0">
          <span class="fs-25 me-2">
            <Icon icon="lets-icons:world-2-light"/>
          </span>
          {{course.resources}} Especialistas internacionales
        </p>
      </li>
      <li v-if="course.certificate" class="c-take-curse__li">
        <p class="mb-0">
          <span class="fs-25 me-2">
            <Icon icon="mdi-light:trophy"/>
          </span>
          Certificado al completar el curso
        </p>
      </li>
      <li class="c-take-curse__li">
        <p class="mb-0">
          <span class="fs-25 me-2">
            <Icon icon="clarity:eye-show-line"/>
          </span>
          Acceso ilimitado
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { enrollAtCourse } from '@/libs/course';

export default {
  data() {
    return {
      isLoadingEnroll: false,

      memberships: {
        data: null,
        loading: true,
      },

      btnLoading: false,
    };
  },
  props: ['course'],
  computed: {
    ...mapState({
      shopCart: (state) => state.shopCart,
    }),

    currency() {
      return this.course.price.symbol;
    },
    membershipPrice() {
      if (this.memberships.data) {
        return {
          current: Number(this.memberships.data.anual.amount_current) / 12,
          before: Number(this.memberships.data.anual.amount_before) / 12,
        };
      }

      return {
        current: 0,
        before: 0,
      };
    },

    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.stateUser;
    },

    checkoutProduct() {
      return `/checkout/course?ids=${this.course.post.id}`;
    },
    objectProductToCart() {
      return {
        id: this.course.post.id,
        title: this.course.post.title,
        slug: this.course.slug,
        thumbnail: this.course.post.thumbnail
          ? this.course.post.thumbnail.src
          : '',
        type: 'course',
        specialist: this.course.specialist,
        price: {
          before: Number(this.course.price.before),
          current: Number(this.course.price.current),
        },
      };
    },
    checkIsOnCart() {
      return this.shopCart.cart
        ? this.shopCart.cart.find((co) => co.id === this.course.post.id)
        : false;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },
  },
  created() {
    this.getMemberships();
  },
  methods: {
    ...mapActions(['addItemToCart', 'removeItemFromCart']),

    enrollAtCourse,
    addToCart() {
      if (this.checkIsOnCart) {
        this.removeItemFromCart({ id: this.course.post.id });
      } else {
        this.addItemToCart(this.objectProductToCart);
      }
    },

    getMemberships() {
      const request = `${process.env.VUE_APP_API}/memberships`;

      this.memberships.loading = true;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.memberships.data = response.data;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.memberships.loading = false;
        });
    },

    getFreeCourseAccess(courseId) {
      this.btnLoading = true;
      fetch(`${process.env.VUE_APP_API}/free-product-access?user=${this.userData.id}&course=${courseId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            setTimeout(() => {
              window.location.href = '/panel';
            }, 2000);
          }
        })
        .catch((err) => {
          this.btnLoading = false;
          throw err;
        });
    },

    handleGetFreeCourseAccess(courseId) {
      if (this.isAuthenticated) {
        this.getFreeCourseAccess(courseId);
      } else {
        this.$bvModal.show('modalLogin');
      }
    },
  },
};
</script>
